<h2 mat-dialog-title class="Dialog-box">
  {{DialogText}}
</h2>
<app-loader></app-loader>
<div mat-dialog-content>
  <form [formGroup]="dialog" (submit)="Save()">
    <mat-checkbox formControlName="Checkbox">I acknowledge selected result(s)</mat-checkbox>
    <mat-form-field class="Signed">
      <mat-label>Acknowledgement signed by</mat-label>
      <input matInput formControlName="SignedBy" maxlength="152" autocomplete="off">
      <mat-hint>Enter name, e.g. {{UserName()}} </mat-hint>
      @if (dialog.controls['SignedBy'].hasError('maxlength')) {
        <mat-error>
          {{maxLength}}
        </mat-error>
      }
      @if (dialog.controls['SignedBy'].hasError('required')) {
        <mat-error>
          {{requiredMessage}}
        </mat-error>
      }
      @if (dialog.controls['SignedBy'].hasError('forbiddenName')) {
        <mat-error>
          {{errorMesage}}
        </mat-error>
      }
      @if (dialog.controls['SignedBy'].hasError('SignedBy')) {
        <mat-error>
          {{dialog.controls['SignedBy'].errors.SignedBy}}
        </mat-error>
      }
    </mat-form-field>
    <div></div>
    <button mat-button color="primary" type="reset" name="reset" (click)="CloseDialog()">Cancel</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="dialog.invalid"
    class="Save-button">Save</button>
  </form>
</div>
